import { Controller } from "@hotwired/stimulus"

// Submits the parent form on change event
// Usage: <select data-controller="form-submit" data-action="change->form-submit#submit">
export default class extends Controller {
  submit() {
    this.element.form.submit()
  }
}
